import { useEffect } from 'react';

const KEYS: { keys: string; does: string }[] = [
  { keys: 'j / k', does: 'Move down and up the unassigned list' },
  { keys: '0–9', does: 'Place the selected presenter on that channel' },
  { keys: 'Enter', does: 'Commit a two-digit channel number' },
  { keys: 'Esc', does: 'Clear the selection, or close a dialog' },
  { keys: 'a', does: 'Auto-assign' },
  { keys: 'd', does: 'Deploy' },
  { keys: '⌘Z / Ctrl+Z', does: 'Undo the last change to the board' },
];

/**
 * What the keyboard does.
 *
 * The shortcuts existed with nothing in the interface mentioning them, so in
 * practice only whoever wrote them knew. They matter most in the dark, which is
 * exactly when nobody is going to go looking for documentation.
 */
export default function Shortcuts({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 420 }} role="dialog" aria-label="Keyboard shortcuts">
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <h2>Keyboard</h2>
          <button className="btn sm" onClick={onClose} aria-label="Close">✕</button>
        </div>
        <p className="sub">On the A2 board, when you are not typing in a field.</p>

        <dl className="keys">
          {KEYS.map(k => (
            <div className="keys-row" key={k.keys}>
              <dt><kbd>{k.keys}</kbd></dt>
              <dd>{k.does}</dd>
            </div>
          ))}
        </dl>

        <p className="hint">
          On a phone, tap a presenter and then tap the channel you want them on.
        </p>
      </div>
    </div>
  );
}
